import { render, staticRenderFns } from "./collectlist.vue?vue&type=template&id=e246d2f8&scoped=true"
import script from "./collectlist.vue?vue&type=script&lang=js"
export * from "./collectlist.vue?vue&type=script&lang=js"
import style0 from "./collectlist.vue?vue&type=style&index=0&id=e246d2f8&prod&scoped=scoped&lang=css"
import style1 from "./collectlist.vue?vue&type=style&index=1&id=e246d2f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e246d2f8",
  null
  
)

export default component.exports